import i18n from 'i18next';
import Api from 'modules/utils/Api';
import {call, put} from 'typed-redux-saga';
import { fetchWeeklyPrizeModalSuccess, type fetchWeeklyPrizeModal} from 'modules/actions/weeklyPrizeModal';

const fetchWeeklyPrizeModalSaga = function* (_action: ReturnType<typeof fetchWeeklyPrizeModal>) {
	const result = yield* call(Api.Jsons.weekly_prize_modal);

	if (result?.data.modals?.length) {
		const modal = result.data.modals.find((it) => it.language === i18n.language);

		if ( modal) {
			yield* put(fetchWeeklyPrizeModalSuccess(modal));
		}
	}
};

export default fetchWeeklyPrizeModalSaga;
